.Layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.skipLink {
  position: absolute;
  left: -9999px;
  top: 0;
  background: var(--yolk);
  color: var(--ink);
  padding: 8px 16px;
  border-radius: var(--radius-sm);
  z-index: 9999;
  font-family: var(--font-body);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;

  &:hover {
    color: var(--ink);
  }

  &:focus,
  &:focus-visible {
    left: 8px;
    top: 8px;
  }
}
